$ = require 'jquery'
Singleton = require '../../pattern/singleton'
Data = require '../data'
Elements = require './elements'
XMLHttpRequest = require '../../components/xml-http-request'
PreloadImage = require '../../components/preload-image'
WorksList = require './works-list'
{ map, reduce } = require 'lodash'

module.exports =
class Loader extends Singleton

  @imagesData: {}

  src:
    title      : /<title>(.*)<\/title>/
    description: /<meta name="description" content="(.*)">/
    keywords   : /<meta name="keywords" content="(.*)">/

  constructor: ->
    super

    @$window = Elements.$window
      .one
        'pagesLoaded'    : @onPagesLoaded
    @$wrap        = $ Elements.selectors.wrap
    @$sectionsInr = $ Elements.$sectionsInr

    @worksList = WorksList.getInstance()

    @$sectionsInr.empty()
    @pagesLoad()

  getImageLoadedRate: ->
    total  = @preloadImage.images.length + @worksList.preloadImage.images.length
    loaded = @preloadImage.loaded + @worksList.preloadImage.loaded
    loaded / total

  pagesLoad: ->

    pages = map Data.directory, (url) ->
      new XMLHttpRequest "#{url}index.html"
    requests = map pages, (page) ->
      page.request()

    $.when.apply @, requests
      .then (data...) =>
        html = reduce data, (memo, data) =>
          Data.title.push @src.title.exec(data)[1]
          Data.description.push @src.description.exec(data)[1]
          Data.keywords.push @src.keywords.exec(data)[1]
          memo + $(data).find(Elements.selectors.sectionsInr).html()
        , ''
        @$sectionsInr.append html
        @$window.trigger 'pagesLoaded'

  onPagesLoaded: =>
    @worksList.load()
    @preloadImage = new PreloadImage Elements.selectors.wrap
    @preloadImage
      .load()
      .then =>
        Loader.imagesData = PreloadImage.data
        @$wrap.css 'display', 'block'
        @$window.trigger 'imagesLoaded'



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/loader.coffee